module.exports = __webpack_public_path__ + "img/158.10df25fd.jpg";